import React, { useState } from "react";
import {RedoOutlined, CloudDownloadOutlined} from '@ant-design/icons';
import {
    Button,
    Row,
    Card,
    Table,
} from "antd";




const columns = [
    {
        title: " Name",
        dataIndex: "name",
    },
    {
        title: " Import Time",
        dataIndex: "importTime",
    },
    {
        title: "End Time",
        dataIndex: "endTime",
    },
    {
        title: "Completed ",
        dataIndex: "completed",
    },
    {
        title: "Total Records",
        dataIndex: "totalRecords",
    },
    {
        title: "Success Count ",
        dataIndex: "successCount",
    },
    {
        title: "Failure Count ",
        dataIndex: "failureCount",
    },
    {
        title: "Download  ",
        dataIndex: "download",
        render:() => <CloudDownloadOutlined/>
    },
];


const data = [{
    key: "",
    name: "",
    importTime: "",
    endTime:"",
    completed:"",
    totalRecords:"",
    successCount:"",
    failureCount:"",   
}]

export default function TableDetails() {
   
    return (

        <Card
            style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
            title={"Documents"}
        >
            <Row style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: "auto" }}>
                    <Button
                        icon={<RedoOutlined />}
                        style={{
                            marginLeft: "auto",
                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            backgroundColor: "#92428B",
                            color: "white",
                            hoverBackground: "#AD4EA7"
                        }}>Refresh</Button>
                </div>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                centered 
                pagination={false}
            />
        </Card>
    );
}
